import * as React from 'react';
import { TDirection } from '@cian/frontend-newbuilding-carousel-component';
import { IconChevronLeft12, IconChevronRight12 } from '@cian/ui-kit/icons';
import classNames from 'classnames';
import * as styles from './Arrow.css';

interface IArrowProps {
  direction: TDirection;
  disabled: boolean;
  clickHandler?(direction: TDirection): void;
}

export const Arrow: React.FC<IArrowProps> = props => {
  const { direction, disabled, clickHandler } = props;

  return (
    <div
      data-testid={direction === 1 ? 'direction-right' : 'direction-left'}
      className={classNames(styles['click_area'], direction < 0 && styles['click_area--left'])}
      onClick={() => {
        return clickHandler && !disabled && clickHandler(direction);
      }}
    >
      <button className={classNames(styles['background'], disabled && styles['click_area--disabled'])}>
        {direction < 0 ? <IconChevronLeft12 color={'white_100'} /> : <IconChevronRight12 color={'white_100'} />}
      </button>
    </div>
  );
};
